import React from 'react';

import CheckIcon from 'assets/livenicons/ic_check.svg';

import styles from './styles.module.scss';

export const AchievedResult = () => {
  return (
    <div className={styles.container}>
      <h3>Our goals</h3>
      <div className={styles.checklist}>
        <p className={styles.checklistItem}>
          <img src={CheckIcon} alt="" />
          <span>You wake up feeling energized</span>
        </p>
        <p className={styles.checklistItem}>
          <img src={CheckIcon} alt="" />
          <span>You no longer feel overwhelmed or worried</span>
        </p>
        <p className={styles.checklistItem}>
          <img src={CheckIcon} alt="" />
          <span>You’re no longer stuck by overthinking</span>
        </p>
        <p className={styles.checklistItem}>
          <img src={CheckIcon} alt="" />
          <span>You enhance your overall emotional well-being</span>
        </p>
        <p className={styles.checklistItem}>
          <img src={CheckIcon} alt="" />
          <span>Boost your energy levels and achieve your goals</span>
        </p>
        <p className={styles.checklistItem}>
          <img src={CheckIcon} alt="" />
          <span>Your self-confidence is at an all-time high</span>
        </p>
      </div>
    </div>
  );
};
